import { render } from "./icon-arrow-left.vue?vue&type=template&id=53077b20"
const script = {}

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__